// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__-AQ5y","slide-down":"Modal_slide-down__D9hHM"};